import { isUndefined } from '@aloft/toolkit-shared';

import { selectEffectiveYear } from '../../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { EditableField } from '../EditableField.tsx';
import { PropertyGridFieldProps } from '../types.ts';
import { formatAgeWithYearBuilt } from '../utils.tsx';

export const AgeWithYearBuiltField = ({
  columnIndex,
  field,
  control,
  getValues,
  setValue,
  colSpan,
  required,
  isArv = false,
}: PropertyGridFieldProps) => {
  const effectiveYear = useAppSelector(selectEffectiveYear);

  const toDisplayValue = (value?: number) => {
    if (isUndefined(value)) return undefined;
    return formatAgeWithYearBuilt(value, effectiveYear);
  };

  const toEditValue = (value?: number) => value?.toString();

  const toValue = (value?: string) => {
    if (isUndefined(value)) return undefined;
    return parseInt(value, 10);
  };

  return (
    <EditableField
      colSpan={colSpan}
      columnIndex={columnIndex}
      field={{
        ...field,
        toDisplayValue,
        toEditValue,
        toValue,
      }}
      isArv={isArv}
      control={control}
      getValues={getValues}
      setValue={setValue}
      required={required}
    />
  );
};
